export const per_110 = 4505 / 4096;
export const per_110_punchglobe = 4506 / 4096;
export const per_150 = 6144 / 4096;
export const per_200 = 8192 / 4096;
export const per_225 = 9216 / 4096;
export const per_050 = 2048 / 4096;
export const per_075 = 3072 / 4096;
export const per_130 = 5324 / 4096;
export const per_130_normal_jewel_field = 5325 / 4096;
export const per_120 = 4915 / 4096;
export const per_100 = 4096 / 4096;
export const per_125 = 5120 / 4096; // 1.25 for かんそうはだ
export const per_133_3 = 5461 / 4096; // 1.333... for ひひいろのこどう
export const per_130_taranzisuta = 5325 / 4096; // 1.3 for トランジスタ

